import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Download, FolderOpen, FileSpreadsheet } from "lucide-react";
import { Button } from "@/components/ui/button";
import { API } from "@/context/AuthContext";
import { inr, dmy, downloadPdf, downloadXlsx } from "@/lib/proforma";

export function PIHistory({ refreshKey, onOpen }) {
  const [rows, setRows] = useState(null);
  useEffect(() => { axios.get(`${API}/proforma`).then((r) => setRows(r.data)).catch(() => setRows([])); }, [refreshKey]);
  if (rows === null) return <p className="text-sm text-slate-500">Loading…</p>;
  if (!rows.length) return <p className="text-sm text-slate-500" data-testid="pi-history-empty">No proforma invoices generated yet.</p>;
  return (
    <div className="overflow-x-auto rounded-lg border border-slate-200 bg-white" data-testid="pi-history">
      <table className="w-full text-sm">
        <thead className="bg-slate-50 text-[11px] uppercase tracking-wide text-slate-500">
          <tr>{["PFI No.", "Date", "Customer", "Search", "Ex-works", "Net payable", "By", ""].map((h) => <th key={h} className="px-3 py-2 text-left font-semibold">{h}</th>)}</tr>
        </thead>
        <tbody className="divide-y divide-slate-100">
          {rows.map((r) => (
            <tr key={r.id} data-testid={`pi-history-row-${r.id}`}>
              <td className="px-3 py-2 font-mono font-semibold">{r.number}</td>
              <td className="px-3 py-2">{dmy(r.date)}</td>
              <td className="px-3 py-2">{r.customer?.name}</td>
              <td className="px-3 py-2 text-xs text-slate-500">{r.mode === "po" ? "PO" : "Project"} {r.query}</td>
              <td className="px-3 py-2 tabular-nums text-right">{inr(r.ex_works)}</td>
              <td className="px-3 py-2 tabular-nums text-right font-semibold">{inr(r.net_payable)}</td>
              <td className="px-3 py-2 text-xs text-slate-500">{r.created_by}</td>
              <td className="px-3 py-2 whitespace-nowrap text-right">
                <Button size="sm" variant="outline" className="mr-2" onClick={() => onOpen(r.id)} data-testid={`pi-history-open-${r.id}`}><FolderOpen className="h-4 w-4 mr-1" />Open</Button>
                <Button size="sm" variant="outline" onClick={() => downloadPdf(r.id, r.number).catch(() => toast.error("PDF download failed"))} data-testid={`pi-history-pdf-${r.id}`}>
                  <Download className="h-4 w-4 mr-1" />PDF</Button>
                <Button size="sm" variant="outline" className="ml-2" onClick={() => downloadXlsx(r.id, r.number).catch(() => toast.error("Excel download failed"))} data-testid={`pi-history-xlsx-${r.id}`}>
                  <FileSpreadsheet className="h-4 w-4 mr-1" />XLS</Button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
